// import React, { useEffect, useState, useContext } from 'react';
// import {
//   Typography, Box, Toolbar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Snackbar, IconButton, CircularProgress, MenuItem, Select, InputLabel, FormControl
// } from '@mui/material';
// import { Add, Edit, Delete } from '@mui/icons-material';
// import AdminSidebar from '../AdminSidebar';
// import Forbidden403 from '../components/common/Forbidden403';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import { API_URL } from "../config";
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import { AuthContext } from '../App';
// import { hasPermission } from "../utils/permissions";

// /**
//  * Jobs admin page for listing, creating, editing, and deleting jobs.
//  * Integrates with backend API using JWT authentication.
//  * Organization must be selected for each job.
//  */
// export default function Jobs() {
//   const { fetchWithAuth, auth } = useContext(AuthContext);
//   const hasListPermission = hasPermission(auth?.user, "job.list") && hasPermission(auth?.user, "organization.list");
//   if (!hasListPermission) {
//     return (
//       <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f7f7fa' }}>
//         <AdminSidebar selected="Jobs" />
//         <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Forbidden403 message="You are not authorized to view jobs. Please contact your system administrator." />
//         </Box>
//       </Box>
//     );
//   }
  
//   const [jobs, setJobs] = useState([]);
//   const [organizations, setOrganizations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogMode, setDialogMode] = useState('create'); // 'create' | 'edit'
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [jobTitle, setJobTitle] = useState('');
//   const [jobDesc, setJobDesc] = useState('');
//   const [orgId, setOrgId] = useState('');
//   const [isActive, setIsActive] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//   const [deleteDialog, setDeleteDialog] = useState({ open: false, job: null });

//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();

//   /** Fetch organizations for dropdown */
//   const fetchOrganizations = async () => {
//     try {
//       const res = await fetchWithAuth(`${API_URL}/organizations/`);
//       if (!res.ok) throw new Error('Failed to fetch organizations');
//       const data = await res.json();
//       setOrganizations(data);
//     } catch (err) {
//       setError(err.message || 'Error fetching organizations');
//     }
//   };

//   /** Fetch jobs from backend API */
//   const fetchJobs = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const res = await fetchWithAuth(`${API_URL}/jobs/`);
//       if (!res.ok) {
//         if (res.status === 403) {
//           setError('You are not authorized to perform this action. Please contact your system administrator.');
//           return;
//         }
//         throw new Error('Failed to fetch jobs');
//       }
//       const data = await res.json();
//       setJobs(data);
//     } catch (err) {
//       setError(err.message || 'Error fetching jobs');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrganizations();
//     fetchJobs();
//     // eslint-disable-next-line
//   }, []);

//   /** Open dialog for creating or editing */
//   const handleOpenDialog = (mode, job = null) => {
//     setDialogMode(mode);
//     setSelectedJob(job);
//     setJobTitle(job ? job.title : '');
//     setJobDesc(job ? job.description : '');
//     setOrgId(job ? job.organization_id : (organizations[0]?.id || ''));
//     setIsActive(job ? job.is_active : true);
//     setOpenDialog(true);
//   };

//   /** Close dialog and reset state */
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedJob(null);
//     setJobTitle('');
//     setJobDesc('');
//     setOrgId('');
//     setIsActive(true);
//   };

//   useEffect(() => {
//     const openParam = searchParams.get("open");
//     if (openParam === "create") {
//       handleOpenDialog("create");
//       navigate("/admin/jobs", { replace: true });
//     }
//   }, [searchParams, navigate]);

//   /** Handle create or update job */
//   const handleSaveJob = async () => {
//     if (!jobTitle.trim() || !orgId) {
//       setSnackbar({ open: true, message: 'Title and organization are required', severity: 'error' });
//       return;
//     }
//     try {
//       setLoading(true);
//       let res;
//       if (dialogMode === 'create') {
//         res = await fetchWithAuth(`${API_URL}/jobs/`, {
//           method: 'POST',
//           body: JSON.stringify({ title: jobTitle, description: jobDesc, organization_id: orgId, is_active: isActive }),
//         });
//       } else {
//         res = await fetchWithAuth(`${API_URL}/jobs/${selectedJob.id}`, {
//           method: 'PUT',
//           body: JSON.stringify({ title: jobTitle, description: jobDesc, organization_id: orgId, is_active: isActive }),
//         });
//       }
//       if (!res.ok) {
//         const errData = await res.json();
//         throw new Error(errData.detail || 'Failed to save job');
//       }
//       setSnackbar({ open: true, message: dialogMode === 'create' ? 'Job created' : 'Job updated', severity: 'success' });
//       handleCloseDialog();
//       fetchJobs();
//     } catch (err) {
//       setSnackbar({ open: true, message: err.message || 'Error saving job', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Open delete confirmation dialog */
//   const handleOpenDelete = (job) => {
//     setDeleteDialog({ open: true, job });
//   };

//   /** Close delete confirmation dialog */
//   const handleCloseDelete = () => {
//     setDeleteDialog({ open: false, job: null });
//   };

//   /** Handle delete job */
//   const handleDeleteJob = async () => {
//     try {
//       setLoading(true);
//       const res = await fetchWithAuth(`${API_URL}/jobs/${deleteDialog.job.id}`, {
//         method: 'DELETE',
//       });
//       if (!res.ok) {
//         const errData = await res.json();
//         throw new Error(errData.detail || 'Failed to delete job');
//       }
//       setSnackbar({ open: true, message: 'Job deleted', severity: 'success' });
//       handleCloseDelete();
//       fetchJobs();
//     } catch (err) {
//       setSnackbar({ open: true, message: err.message || 'Error deleting job', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <AdminSidebar selected="Jobs" />
//       <Box component="main" sx={{ flexGrow: 1, pl: 3, pr: 2, pt: 2 }}>
//         <Toolbar />
//         <Container maxWidth="md" sx={{ py: { xs: 2, sm: 4 }, px: { xs: 1, sm: 3 } }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//             <Typography variant="h5" sx={{ fontWeight: 700 }}>
//               Jobs
//             </Typography>
//             <Button variant="contained" startIcon={<Add />} onClick={() => handleOpenDialog('create')}>
//               Add Job
//             </Button>
//           </Box>
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : error ? (
//             <Typography color="error">{error}</Typography>
//           ) : (
//             <TableContainer component={Paper} sx={{ mt: 1 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Title</TableCell>
//                     <TableCell>Organization</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="right">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {jobs.map((job) => (
//                     <TableRow key={job.id}>
//                       <TableCell>{job.title}</TableCell>
//                       <TableCell>{organizations.find((org) => org.id === job.organization_id)?.name || '-'}</TableCell>
//                       <TableCell>{job.is_active ? 'Active' : 'Inactive'}</TableCell>
//                       <TableCell align="right">
//                         <IconButton size="small" onClick={() => handleOpenDialog('edit', job)} aria-label="edit">
//                           <Edit fontSize="small" />
//                         </IconButton>
//                         <IconButton size="small" onClick={() => handleOpenDelete(job)} aria-label="delete" color="error">
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}
//         </Container>
//         {/* Create/Edit Dialog */}
//         <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
//           <DialogTitle>{dialogMode === 'create' ? 'Add Job' : 'Edit Job'}</DialogTitle>
//           <DialogContent>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Job Title"
//               type="text"
//               fullWidth
//               value={jobTitle}
//               onChange={(e) => setJobTitle(e.target.value)}
//               disabled={loading}
//             />
//             {/* Job Description - Rich Text Editor */}
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                 Job Description
//               </Typography>
//               <Box sx={{
//                 '.ql-toolbar': {
//                   borderTopLeftRadius: 10,
//                   borderTopRightRadius: 10,
//                   position: 'sticky',
//                   top: 0,
//                   zIndex: 2,
//                   background: '#fff',
//                 },
//                 '.ql-container': {
//                   height: 300,
//                   maxHeight: 300,
//                   overflowY: 'auto',
//                   borderBottomLeftRadius: 10,
//                   borderBottomRightRadius: 10,
//                   background: '#fff',
//                 },
//                 borderRadius: 10,
//                 border: '1px solid #ddd',
//                 boxSizing: 'border-box',
//                 mb: 2
//               }}>
//                 <ReactQuill
//                   theme="snow"
//                   value={jobDesc}
//                   onChange={setJobDesc}
//                   readOnly={loading}
//                 />
//               </Box>
//             </Box>
//             <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
//               <InputLabel id="org-label">Organization</InputLabel>
//               <Select
//                 labelId="org-label"
//                 value={orgId}
//                 label="Organization"
//                 onChange={(e) => setOrgId(e.target.value)}
//                 disabled={loading}
//               >
//                 {organizations.map((org) => (
//                   <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
//               <InputLabel id="status-label">Status</InputLabel>
//               <Select
//                 labelId="status-label"
//                 value={isActive ? 'active' : 'inactive'}
//                 label="Status"
//                 onChange={(e) => setIsActive(e.target.value === 'active')}
//                 disabled={loading}
//               >
//                 <MenuItem value="active">Active</MenuItem>
//                 <MenuItem value="inactive">Inactive</MenuItem>
//               </Select>
//             </FormControl>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} disabled={loading}>Cancel</Button>
//             <Button onClick={handleSaveJob} variant="contained" disabled={loading}>
//               {dialogMode === 'create' ? 'Create' : 'Update'}
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* Delete Confirmation Dialog */}
//         <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
//           <DialogTitle>Delete Job</DialogTitle>
//           <DialogContent>
//             <Typography>Are you sure you want to delete this job?</Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDelete} disabled={loading}>Cancel</Button>
//             <Button onClick={handleDeleteJob} color="error" variant="contained" disabled={loading}>Delete</Button>
//           </DialogActions>
//         </Dialog>
//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           message={snackbar.message}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//         />
//       </Box>
//     </Box>
//   );
// }


import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Box,
  Toolbar,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Alert,
  Chip,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Add, Edit, Delete } from "@mui/icons-material";
import AdminSidebar from "../AdminSidebar";
import Forbidden403 from "../components/common/Forbidden403";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_URL } from "../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import { hasPermission } from "../utils/permissions";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

export default function Jobs() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const borderStrong = dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4";

  const { fetchWithAuth, auth } = useContext(AuthContext);
  const hasListPermission =
    hasPermission(auth?.user, "job.list") &&
    hasPermission(auth?.user, "organization.list");

  const [jobs, setJobs] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMode, setDialogMode] = useState("create");
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobTitle, setJobTitle] = useState("");
  const [jobDesc, setJobDesc] = useState("");
  const [orgId, setOrgId] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, job: null });

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!hasListPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Jobs" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 message="You are not authorized to view jobs. Please contact your system administrator." />
        </Box>
      </Box>
    );
  }

  const fetchOrganizations = async () => {
    try {
      const res = await fetchWithAuth(`${API_URL}/organizations/`);
      if (!res.ok) throw new Error("Failed to fetch organizations");
      const data = await res.json();
      setOrganizations(data);
    } catch (err) {
      setError(err.message || "Error fetching organizations");
    }
  };

  const fetchJobs = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchWithAuth(`${API_URL}/jobs/`);
      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error("Failed to fetch jobs");
      }
      const data = await res.json();
      setJobs(data);
    } catch (err) {
      setError(err.message || "Error fetching jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
    fetchJobs();
  }, []);

  const handleOpenDialog = (mode, job = null) => {
    setDialogMode(mode);
    setSelectedJob(job);
    setJobTitle(job ? job.title : "");
    setJobDesc(job ? job.description : "");
    setOrgId(job ? job.organization_id : organizations[0]?.id || "");
    setIsActive(job ? job.is_active : true);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedJob(null);
    setJobTitle("");
    setJobDesc("");
    setOrgId("");
    setIsActive(true);
  };

  useEffect(() => {
    const openParam = searchParams.get("open");
    if (openParam === "create") {
      handleOpenDialog("create");
      navigate("/admin/jobs", { replace: true });
    }
  }, [searchParams, navigate]);

  const handleSaveJob = async () => {
    if (!jobTitle.trim() || !orgId) {
      setSnackbar({
        open: true,
        message: "Title and organization are required",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      let res;

      if (dialogMode === "create") {
        res = await fetchWithAuth(`${API_URL}/jobs/`, {
          method: "POST",
          body: JSON.stringify({
            title: jobTitle,
            description: jobDesc,
            organization_id: orgId,
            is_active: isActive,
          }),
        });
      } else {
        res = await fetchWithAuth(`${API_URL}/jobs/${selectedJob.id}`, {
          method: "PUT",
          body: JSON.stringify({
            title: jobTitle,
            description: jobDesc,
            organization_id: orgId,
            is_active: isActive,
          }),
        });
      }

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Failed to save job");
      }

      setSnackbar({
        open: true,
        message: dialogMode === "create" ? "Job created" : "Job updated",
        severity: "success",
      });

      handleCloseDialog();
      fetchJobs();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error saving job",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDelete = (job) => {
    setDeleteDialog({ open: true, job });
  };

  const handleCloseDelete = () => {
    setDeleteDialog({ open: false, job: null });
  };

  const handleDeleteJob = async () => {
    try {
      setLoading(true);
      const res = await fetchWithAuth(`${API_URL}/jobs/${deleteDialog.job.id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Failed to delete job");
      }

      setSnackbar({
        open: true,
        message: "Job deleted",
        severity: "success",
      });

      handleCloseDelete();
      fetchJobs();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error deleting job",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Jobs" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Jobs</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage job descriptions.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  Create, update, and maintain job descriptions linked to your
                  organization.
                </Typography>
              </Box>

              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => handleOpenDialog("create")}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1.1,
                  background: accent,
                  boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                  "&:hover": {
                    background: accent,
                    filter: "brightness(1.08)",
                  },
                }}
              >
                Add Job
              </Button>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 260,
                }}
              >
                <CircularProgress sx={{ color: accent }} />
              </Box>
            ) : error ? (
              <Alert severity="error" sx={{ borderRadius: "18px" }}>
                {error}
              </Alert>
            ) : (
              <TableContainer
                sx={{
                  borderRadius: "18px",
                  border: `1px solid ${border}`,
                  overflowX: "auto",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {["Title", "Organization", "Status", "Actions"].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            fontWeight: 700,
                            color: mid,
                            background: dark ? "#111827" : "#fafafa",
                            borderBottom: `1px solid ${border}`,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {jobs.map((job) => (
                      <TableRow
                        key={job.id}
                        hover
                        sx={{
                          "& td": {
                            borderBottom: `1px solid ${border}`,
                            background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                            color: mid,
                          },
                          "&:hover td": {
                            background: dark
                              ? "rgba(255,255,255,0.03)"
                              : "rgba(15,15,26,0.02)",
                          },
                        }}
                      >
                        <TableCell sx={{ color: text, fontWeight: 700 }}>
                          {job.title}
                        </TableCell>

                        <TableCell>
                          {organizations.find((org) => org.id === job.organization_id)?.name || "-"}
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={job.is_active ? "Active" : "Inactive"}
                            size="small"
                            sx={{
                              borderRadius: 999,
                              fontWeight: 700,
                              background: job.is_active
                                ? dark
                                  ? "rgba(34,197,94,0.18)"
                                  : "rgba(34,197,94,0.10)"
                                : dark
                                ? "rgba(148,163,184,0.16)"
                                : "rgba(148,163,184,0.12)",
                              color: job.is_active
                                ? dark
                                  ? "#86efac"
                                  : "#15803d"
                                : dark
                                ? "#cbd5e1"
                                : "#374151",
                              border: `1px solid ${
                                job.is_active
                                  ? dark
                                    ? "rgba(34,197,94,0.24)"
                                    : "rgba(34,197,94,0.18)"
                                  : dark
                                  ? "rgba(148,163,184,0.24)"
                                  : "rgba(148,163,184,0.18)"
                              }`,
                            }}
                          />
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDialog("edit", job)}
                            aria-label="edit"
                            sx={{ color: mid, mr: 0.5 }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDelete(job)}
                            aria-label="delete"
                            sx={{ color: "#dc2626" }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}

                    {jobs.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          <Typography sx={{ py: 3, color: muted }}>
                            No jobs found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Container>

        <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            {dialogMode === "create" ? "Add Job" : "Edit Job"}
          </DialogTitle>

          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              label="Job Title"
              type="text"
              fullWidth
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              disabled={loading}
              sx={{ mb: 2 }}
            />

            <Box sx={{ mt: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, fontWeight: 700, color: text }}
              >
                Job Description
              </Typography>

              <Box
                sx={{
                  ".ql-toolbar": {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    background: dark ? "#111827" : "#fff",
                    borderColor: border,
                  },
                  ".ql-container": {
                    height: 300,
                    maxHeight: 300,
                    overflowY: "auto",
                    borderBottomLeftRadius: 10,
                    borderBottomRightRadius: 10,
                    background: dark ? "#0b1220" : "#fff",
                    borderColor: border,
                    color: text,
                  },
                  ".ql-editor": {
                    color: text,
                  },
                  ".ql-snow .ql-stroke": {
                    stroke: dark ? "#cbd5e1" : undefined,
                  },
                  ".ql-snow .ql-fill": {
                    fill: dark ? "#cbd5e1" : undefined,
                  },
                  ".ql-snow .ql-picker": {
                    color: dark ? "#cbd5e1" : undefined,
                  },
                  borderRadius: 10,
                  border: `1px solid ${border}`,
                  boxSizing: "border-box",
                  mb: 2,
                }}
              >
                <ReactQuill
                  theme="snow"
                  value={jobDesc}
                  onChange={setJobDesc}
                  readOnly={loading}
                />
              </Box>
            </Box>

            <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
              <InputLabel id="org-label">Organization</InputLabel>
              <Select
                labelId="org-label"
                value={orgId}
                label="Organization"
                onChange={(e) => setOrgId(e.target.value)}
                disabled={loading}
              >
                {organizations.map((org) => (
                  <MenuItem key={org.id} value={org.id}>
                    {org.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                value={isActive ? "active" : "inactive"}
                label="Status"
                onChange={(e) => setIsActive(e.target.value === "active")}
                disabled={loading}
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} disabled={loading}>
              Cancel
            </Button>
            <Button onClick={handleSaveJob} variant="contained" disabled={loading}>
              {dialogMode === "create" ? "Create" : "Update"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Delete Job
          </DialogTitle>

          <DialogContent dividers>
            <Typography sx={{ color: mid }}>
              Are you sure you want to delete this job?
            </Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDelete} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleDeleteJob}
              color="error"
              variant="contained"
              disabled={loading}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}
